module.exports = __webpack_public_path__ + "img/xk.a4f5eed9.svg";